import { configureStore } from '@reduxjs/toolkit';
import rolesPermissionsReducer from './ACL/ACLSlice';

export const AclStore = configureStore({
  reducer: {
    rolesPermissions: rolesPermissionsReducer,
  },
});
